// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","280":"d2e8414d","513":"73eb4cb0","632":"0cfc37b0","706":"711ede07","726":"759a3e6d"}[chunkId] + ".chunk.js";
};